import * as ActionType from '../../constants/actionType';

export const setSystemInformationData = (data) => ({
  type: ActionType.SET_SYSTEM_INFORMATION_DATA,
  data,
});

export const setIsUpdating = (isUpdating) => ({
  type: ActionType.SET_IS_UPDATING,
  isUpdating,
});

export const setIsDowngrading = (isDowngrading) => ({
  type: ActionType.SET_IS_DOWNGRADING,
  isDowngrading,
});

export const setIsFinalizing = (isFinalizing) => ({
  type: ActionType.SET_IS_FINALIZING,
  isFinalizing,
});
